// extracted by mini-css-extract-plugin
export default {"paper-outer-margin":"styles_paper-outer-margin__5PuPA","paper-inner-spacing-sides":"styles_paper-inner-spacing-sides__fNije"};